import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  ValidationErrors,
  AbstractControl,
} from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../../environments/environment";
import { AuthenticationService } from "../../../services/authentication.service";
import { NotificationService } from "../../../services/notification.service";
import { PlanService } from "../../../services/plan.service";
import { Carta } from "../../../models/carta";
import { Local } from "../../../models/local";
import { Promo } from "../../../models/promo";
import { Plan } from "../../../models/plan";

interface Activar {
  locales: Array<Local>;
  promos: Array<Promo>;
}

@Component({
  selector: "app-plan-review",
  templateUrl: "./plan-review.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./plan-review.component.scss"],
})
export class PlanReviewComponent implements OnInit {
  @Input()
  public cartas: Array<Carta>;
  @Input()
  public locales: Array<Local>;
  @Input()
  public promosInApp: Array<Promo>;
  @Input()
  public promosQR: Array<Promo>;

  public form: FormGroup;
  public plan: Plan;
  public submitted: boolean;
  public tab: number = 1;
  public cantidadPromoInApp: number = 0;
  public cantidadPromoQR: number = 0;
  public cantidadCarta: number = 0;
  public cantidadLocal: number = 0;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private planService: PlanService
  ) {
    this.submitted = false;
    this.cartas = [];
    this.locales = [];
    this.promosInApp = [];
    this.promosQR = [];

    this.plan = this.authenticationService.currentUserValue.user.plan;
  }

  ngOnInit() {
    this.form = this.formBuilder.group(
      {
        locales: this.formBuilder.array(
          [],
          this.locales.length > 0
            ? [Validators.required, Validators.min(1), this.checkLimit]
            : []
        ),
        promosInApp: this.formBuilder.array(
          [],
          this.promosInApp.length > 0
            ? [Validators.required, Validators.min(1), this.checkLimit]
            : []
        ),
        promosQR: this.formBuilder.array(
          [],
          this.promosQR.length > 0
            ? [Validators.required, Validators.min(1), this.checkLimit]
            : []
        ),
      },
      {
        validator: [],
      }
    );

    for (const key in this.locales) {
      const element: Local = this.locales[key];

      (this.form.get("locales") as FormArray).push(
        new FormGroup({
          id: new FormControl({
            value: element.id,
            disabled: false,
          }),
          activo: new FormControl({
            value: false,
            disabled: false,
          }),
          nombre: new FormControl({
            value: element.nombre,
            disabled: false,
          }),
          descripcion: new FormControl({
            value: element.descripcion,
            disabled: false,
          }),
          createdAt: new FormControl({
            value: element.createdAt,
            disabled: false,
          }),
        })
      );
    }

    for (const key in this.promosInApp) {
      const element: Promo = this.promosInApp[key];

      (this.form.get("promosInApp") as FormArray).push(
        new FormGroup({
          id: new FormControl({
            value: element.id,
            disabled: false,
          }),
          activa: new FormControl({
            value: false,
            disabled: false,
          }),
          titulo: new FormControl({
            value: element.titulo,
            disabled: false,
          }),
          descripcion: new FormControl({
            value: element.descripcion,
            disabled: false,
          }),
          createdAt: new FormControl({
            value: element.createdAt,
            disabled: false,
          }),
        })
      );
    }

    for (const key in this.promosQR) {
      const element: Promo = this.promosQR[key];

      (this.form.get("promosQR") as FormArray).push(
        new FormGroup({
          id: new FormControl({
            value: element.id,
            disabled: false,
          }),
          activa: new FormControl({
            value: false,
            disabled: false,
          }),
          titulo: new FormControl({
            value: element.titulo,
            disabled: false,
          }),
          descripcion: new FormControl({
            value: element.descripcion,
            disabled: false,
          }),
          createdAt: new FormControl({
            value: element.createdAt,
            disabled: false,
          }),
        })
      );
    }
  }

  public checkLimit(control: AbstractControl): ValidationErrors | null {
    const elements: FormGroup[] = (control as FormArray)
      .controls as FormGroup[];
    let cantidad: number = 0;

    for (const key in elements) {
      const element: FormGroup = elements[key];

      if (element.contains("activa") && element.get("activa").value) {
        cantidad++;
      } else {
        if (element.contains("activo") && element.get("activo").value) {
          cantidad++;
        }
      }
    }

    return cantidad < 2 ? { checkLimit: { value: control.value } } : null;
  }

  /**
   * isLocal
   */
  public isLocal(formGroup: FormGroup): void {
    const elements: FormGroup[] = (formGroup.parent as FormArray)
      .controls as FormGroup[];

    if (
      this.cantidadLocal < this.plan.configuracion.localLimit ||
      !formGroup.get("activo").value
    ) {
      if (formGroup.get("activo").value) {
        this.cantidadLocal++;
      } else {
        this.cantidadLocal--;
      }
    } else {
      this.notificationService.error(
        "Solo puede tener " +
          this.plan.configuracion.localLimit +
          " locales activos"
      );

      formGroup.get("activo").setValue(false);
    }
  }

  /**
   * isPromoInApp
   */
  public isPromoInApp(event: Event, formGroup: FormGroup): void {
    const elements: FormGroup[] = (formGroup.parent as FormArray)
      .controls as FormGroup[];

    if (
      this.cantidadPromoInApp < this.plan.configuracion.promoLimitInApp ||
      !formGroup.get("activa").value
    ) {
      if (formGroup.get("activa").value) {
        this.cantidadPromoInApp++;
      } else {
        this.cantidadPromoInApp--;
      }
    } else {
      this.notificationService.error(
        "Solo puede tener " +
          this.plan.configuracion.promoLimitInApp +
          " promos In App activas"
      );

      formGroup.get("activa").setValue(false);
    }
  }

  /**
   * isPromoQr
   */
  public isPromoQr(formGroup: FormGroup): void {
    const elements: FormGroup[] = (formGroup.parent as FormArray)
      .controls as FormGroup[];

    if (
      this.cantidadPromoQR < this.plan.configuracion.promoLimitQr ||
      !formGroup.get("activa").value
    ) {
      if (formGroup.get("activa").value) {
        this.cantidadPromoQR++;
      } else {
        this.cantidadPromoQR--;
      }
    } else {
      this.notificationService.error(
        "Solo puede tener " +
          this.plan.configuracion.promoLimitQr +
          " promos QR activas"
      );

      formGroup.get("activa").setValue(false);
    }
  }

  /**
   * activar
   */
  public activar(): void {
    if (this.form.valid) {
      const activar: Activar = {
        locales: [],
        promos: [],
      };

      const locales: Array<AbstractControl> = (
        this.form.get("locales") as FormArray
      ).controls;

      for (const key in locales) {
        const element: AbstractControl = locales[key];

        if (element.get("activo").value) {
          activar.locales.push({
            id: element.get("id").value,
          });
        }
      }

      const promosInApp: Array<AbstractControl> = (
        this.form.get("promosInApp") as FormArray
      ).controls;

      for (const key in promosInApp) {
        const element: AbstractControl = promosInApp[key];

        if (element.get("activa").value) {
          activar.promos.push({
            id: element.get("id").value,
          });
        }
      }

      const promosQR: Array<AbstractControl> = (
        this.form.get("promosQR") as FormArray
      ).controls;

      for (const key in promosQR) {
        const element: AbstractControl = promosQR[key];

        if (element.get("activa").value) {
          activar.promos.push({
            id: element.get("id").value,
          });
        }
      }

      if (
        activar.locales.length <= this.plan.configuracion.localLimit &&
        activar.promos.length <=
          this.plan.configuracion.promoLimitInApp +
            this.plan.configuracion.promoLimitQr
      ) {
        this.submitted = true;

        this.planService
          .checkLimit(activar)
          .toPromise()
          .then(
            (message: string) => {
              this.notificationService.success("Actualizado correctamente");
              this.submitted = false;
              this.activeModal.close(message);
            },
            (error: HttpErrorResponse) => {
              this.notificationService.error(
                "No se ha guardado los cambios",
                error
              );
            }
          );
      } else {
        this.notificationService.error(
          "Su plan " +
            this.plan.titulo +
            " solo acepta " +
            this.plan.configuracion.localLimit +
            " locales activos. " +
            this.plan.configuracion.promoLimitInApp +
            " promos In App activos. " +
            this.plan.configuracion.promoLimitQr +
            " promos QR activos."
        );
      }
    } else {
      this.notificationService.error(
        `Debes seleccionar ${this.plan.configuracion.promoLimitQr} promociones QR y ${this.plan.configuracion.promoLimitInApp} promociones in.app para poder guardar tus cambios.`
      );
    }
  }

  public changeTap(tab: number): void {
    this.tab = tab;
  }
}
